import { useEffect, useState } from "react";
import { UserAgent, Registerer, Inviter, RegistererState, SessionState } from "sip.js";
import {
  cleanupMedia,
  connectingCallRigton,
  detectAudioVideoPermission,
  getObjectCount,
  InComingCallRington,
  setupRemoteMedia,
} from "../../utils/sipUtilsFunc";
import { useDispatch, useSelector } from "react-redux";
import {
  clearSIPCalls,
  removeSessionData,
  setCallIncomingOutGoingSession,
  setConnectedInfo,
  setOngoingSessionStatus,
  setRegisterer,
  setRegistererState,
  setUserAgent,
  updateSipState,
} from "../../features/SIP/SIPCallsSlice";
import { CallDirection, ConnectingStatus } from "../../constants/SIPEnums";
import { updateSipConfig } from "../../features/SIP/SIPConfigSlice";
import toast from "react-hot-toast";
import { closeModal, setModal } from "../../features/modal/ModalSlice";
import { v4 as uuidV4 } from "uuid";

const sipConfig = {
  _logEnable: false,
  _iceServer: "stun:stun.l.google.com:19302",
};

// const sipServerURL = process.env.REACT_APP_VOIP_SERVER_BASE_URL;
const sipWebSocketURL = process.env.REACT_APP_VOIP_WEBSOCKET_BASE_URL;

export const TerminateSessions = (session, callDirection) => {
  switch (session?.state) {
    case SessionState.Establishing:
      if (callDirection === CallDirection.Outbound) {
        session.cancel();
      }
      if (callDirection === CallDirection.Inbound) {
        session.reject(603);
      }
      cleanupMedia();
      break;
    case SessionState.Established:
      session.bye();
      cleanupMedia();
      break;
    case SessionState.Terminating:
      break;
    case SessionState.Terminated:
      // console.debug('SessionState.Terminated')
      cleanupMedia();
      break;
    default:
      cleanupMedia();
      break;
  }
};

export const useSIP = () => {
  const mediaElement = typeof document !== "undefined" && document.querySelector("#mediaElement");

  const SipConfiguration = useSelector((state) => state.SIPConfig);

  const {
    sessions,
    sessionId,
    callDirection,
    outgoingSession,
    incomingSession,
    Session_Count,
    sessionState,
    regState,
    userAgent,
  } = useSelector((state) => state.SIPCalls);

  const dispatch = useDispatch();

  const connectSIP = ({
    sipUsername,
    sipPassword,
    webSocketUrl = sipWebSocketURL,
    // sipServer = sipServerURL,
    sipServer,
  }) => {
    if (sipUsername && sipPassword && sipServer && webSocketUrl) {
      try {
        dispatch(updateSipConfig({ sipUsername, sipPassword, webSocketUrl, sipServer }));

        console.log("sipconfig", sipUsername, sipPassword, sipServer, webSocketUrl);

        const sip_aor = `sip:${sipUsername}@${sipServer}`;

        const registererOptions = {};
        const userAgentOptions = {
          uri: UserAgent.makeURI(sip_aor),
          transportOptions: {
            server: webSocketUrl,
            traceSip: true,
          },
          authorizationPassword: sipPassword,
          authorizationUsername: sipUsername,
          dtmfType: "info",
          contactTransport: "wss",
          noAnswerTimeout: 60,
          displayName: sipUsername,
          contactParams: { transport: "wss" },
          keepAliveInterval: 10,
          maxReconnectionAttempts: 3,
          expires: 3000,
          hackIpInContact: true,
          sessionDescriptionHandlerFactoryOptions: {
            peerConnectionOptions: {
              rtcpMuxPolicy: "negotiate",
              iceCheckingTimeout: 1000,
              iceTransportPolicy: "all",
              iceServers: [{ urls: sipConfig?._iceServer }],
            },
          },
          logBuiltinEnabled: sipConfig?._logEnable,
        };

        console.log("user", userAgentOptions);

        const USERAGENT = new UserAgent(userAgentOptions);
        const registerer = new Registerer(USERAGENT, registererOptions);
        USERAGENT.start()
          .then(() => {
            registerer.stateChange.addListener((newState) => {
              dispatch(setRegistererState(newState));
              switch (newState) {
                case RegistererState.Initial:
                  console.log("UserAgent ==> Initial");
                  break;
                case RegistererState.Registered:
                  console.log("UserAgent ==> Registered");
                  break;
                case RegistererState.Unregistered:
                  console.log("UserAgent ==> Unregistered");
                  break;
                case RegistererState.Terminated:
                  console.warn("UserAgent ==> Terminated");
                  USERAGENT.stop();
                  break;
                default:
                  console.log("UserAgent ==> Unidentified");
                  break;
              }
            });
            registerer
              .register()
              .then(() => {
                console.log("Successfully sent REGISTER, object is here");
                const connectedInfo = {
                  connected: true,
                  connectingStatus: ConnectingStatus.Connected,
                };

                dispatch(setRegisterer(registerer));
                dispatch(setConnectedInfo(connectedInfo));
                dispatch(setUserAgent(USERAGENT));
              })
              .catch((error) => {
                console.log("Failed to send REGISTER", error);
              });
          })
          .catch((error) => {
            const connectedInfo = {
              connected: false,
              connectingStatus: ConnectingStatus.Failed,
            };
            dispatch(setConnectedInfo(connectedInfo));
            dispatch(setRegistererState("Unregistered"));
            // console.debug('user agent connect error', error)
            alert("User Agent Unregistered");
            console.log("User agent connection error: ", error);
          });

        /*
         * Setup handling for incoming INVITE requests
         */

        USERAGENT.delegate = {
          async onInvite(invitation) {
            const number = invitation?.remoteIdentity?.uri?.user || "";
            const headers = invitation.request.headers;
            let callUUid = "";
            const callIdHeaders = headers["X-Call-Id"];
            if (callIdHeaders && callIdHeaders?.length > 0) {
              callUUid = callIdHeaders[0]?.raw || "";
            }
            console.log("CallUUID", callUUid);

            dispatch(updateSipState({ key: "sipRecentCallUUID", value: callUUid }));

            const incomingSession = {
              callDirection: CallDirection.Inbound,
              session: invitation,
              sessionId: invitation.id,
            };
            dispatch(setCallIncomingOutGoingSession(incomingSession));
            dispatch(updateSipState({ key: "dialNumber", value: number }));

            dispatch(setModal({ type: "CALL_DIALPAD" }));
            console.log("received...");
            connectingCallRigton("play");

            const callerId = invitation?.localIdentity?.uri?.user || "";
            const calleridNumber = invitation?.remoteIdentity?.uri?.user;

            dispatch(updateSipState({ key: "incomingCustomerName", value: "" }));
            dispatch(updateSipState({ key: "selectedCallerid", value: calleridNumber }));
            updateSipState({ key: "selectedPhoneNum", value: [] });

            const has_video = false;

            dispatch(updateSipState({ key: "callId", value: number }));

            invitation.stateChange.addListener((state) => {
              dispatch(setOngoingSessionStatus(state));
              // dispatch(updateSipState({ key: 'incomingSessionState', value: state }))
              switch (state) {
                case "Initial":
                  console.log("incomming session state Initial");
                  connectingCallRigton("play");
                  break;
                case "Establishing":
                  console.log("Incoming Session state Establishing");
                  connectingCallRigton("play");
                  break;
                case "Established":
                  connectingCallRigton("pause");
                  console.log("Incoming Session state Established");
                  dispatch(
                    updateSipState({
                      key: "ConnectingCallModalToggle",
                      value: false,
                    })
                  );
                  setupRemoteMedia(invitation, has_video);
                  break;
                case "Terminating":
                  connectingCallRigton("pause");
                  dispatch(removeSessionData(invitation?.id));
                  break;
                case "Terminated":
                  connectingCallRigton("pause");
                  dispatch(removeSessionData(invitation?.id));
                  cleanupMedia();
                  dispatch(
                    updateSipState({
                      key: "ConnectingCallModalToggle",
                      value: false,
                    })
                  );
                  dispatch(
                    updateSipState({
                      key: "IncomingCallModalToggle",
                      value: false,
                    })
                  );

                  if (!sessions && getObjectCount(sessions) === 0) dispatch(closeModal());
                  // dispatch(updateSipState({ key: 'callDirection', value: CallDirection.Outbound }))
                  // console.debug('Incoming Session state Terminated')
                  break;
                default:
                // console.debug('Unknow Incomming Session state')
              }
            });
          },

          onConnect() {
            const connectedInfo = {
              connected: true,
              connectingStatus: ConnectingStatus.Connected,
            };
            dispatch(setConnectedInfo(connectedInfo));
          },

          onDisconnect(error) {
            registerer.unregister();
            if (error) {
              // attemptReconnection();
              // console.info('trying to reconnect')
            }
            const connectedInfo = {
              connected: false,
              connectingStatus: ConnectingStatus.Failed,
            };
            dispatch(setRegisterer({}));
            dispatch(setUserAgent({}));
            dispatch(setConnectedInfo(connectedInfo));
          },
        };
      } catch (error) {
        console.log("userAgent create Error", error);
      }
    } else {
      alert("invaid Sip Configuration");
    }
  };

  // Make an outgoing call to a phone number
  const dialCall = async (number) => {
    /*eslint newline-before-return: "error"*/
    const check_permission = await detectAudioVideoPermission();
    if (regState === RegistererState.Registered) {
      // SipConfiguration;
      if (check_permission) {
        if (number !== "") {
          const uri = UserAgent.makeURI(`sip:${number}@${SipConfiguration.sipServer}`);
          const callUUid = uuidV4();
          dispatch(updateSipState({ key: "sipRecentCallUUID", value: callUUid }));
          const _headers = [`X-Call-Id:${callUUid}`, `X-Source:tryout`];
          const earlyMedia = true;
          const inviteOptions = {
            sessionDescriptionHandlerOptions: {
              constraints: {
                audio: true,
                video: false,
              },
            },
            extraHeaders: _headers,
            earlyMedia,
            // contactParams: { transport: 'wss' },
          };

          const session = await new Inviter(userAgent, uri, inviteOptions);

          dispatch(updateSipState({ key: "dialNumber", value: number }));

          const setSession = {
            callDirection: CallDirection.Outbound,
            session,
            sessionId: session.id,
          };
          dispatch(updateSipState({ key: "callId", value: session?.request?.callId }));
          dispatch(setCallIncomingOutGoingSession(setSession));

          // Handle outgoing session state changes
          session.stateChange.addListener((newState) => {
            dispatch(setOngoingSessionStatus(newState));
            switch (newState) {
              case SessionState.Establishing:
                // Session is establishing
                // console.debug('Session is establishing')
                connectingCallRigton("play");
                break;
              case SessionState.Established:
                connectingCallRigton("pause");
                dispatch(updateSipState({ key: "showLoaddingTimer", value: false }));
                // Session has been established
                // console.debug('Session has been ==> Established  ')
                setupRemoteMedia(session, false);
                break;
              case SessionState.Terminated:
                connectingCallRigton("pause");
                // console.debug('Session Has Been Terminated')
                dispatch(removeSessionData(session?.id));
                dispatch(updateSipState({ key: "showDtmf", value: false }));
                break;
              default:
                break;
            }
          });
          // Setup outgoing session delegate
          session.delegate = {
            // Handle outgoing REFER request
            onRefer(referral) {
              // console.log("Handle outgoing REFER request");
              referral.accept().then(() => {
                referral.makeInviter().invite();
              });
            },
          };

          // Options including delegate to capture response messages
          const inviteOptionsOB = {
            requestDelegate: {
              onReject: () => {
                //  dispatch(removeSessionData(session._id));
                // console.log(response);
                //  cleanupMedia();
              },
              onAccept: () => {
                // console.debug('Session Request Is Accepted <===>')
              },
              onProgress: () => {
                // console.debug('onpogress Session <===>')
                //  dispatch(toggleConnectingCall(true));
                // console.debug('onpogressing session=========================')
              },
              onCancel: () => {
                // console.debug('cancel session====')
              },
            },

            sessionDescriptionHandlerOptions: {
              constraints: {
                audio: true,
                video: false,
              },
            },
          };

          // Send invitation
          session
            .invite(inviteOptionsOB)
            .then(() => {
              // console.log('Successfully sent INVITE ....')
              // console.log(request);
            })
            .catch((error) => {
              // console.log('Failed to send INVITE ==> ', error)
            });
        } else {
          alert("please Enter Number");
        }
      } else {
        console.debug("check_permission", check_permission);
        toast.error("Permissions not grated!");
      }
    } else {
      alert("User Agent Disconnected");
    }
  };

  /*
holdCall= false session unhold state  show  hold button
holdCall= true session hold state  show  unhold button
*/
  const [holdCall, setHoldCall] = useState(false); // false session unhold state  show  hold button

  /*
muteCall =  false session unmute show mute button
muteCall   =   true session mute show unmute button
*/
  const [muteCall, setMuteCall] = useState(false);

  useEffect(() => {
    if (
      [SessionState.Initial, SessionState.Establishing, "", SessionState.Terminated].includes(
        sessionState
      )
    ) {
      setHoldCall(false);
      setMuteCall(false);
    }
  }, [sessionState]);

  // current ongoing sessions
  const session = sessions[sessionId];

  const endCall = () => {
    connectingCallRigton("pause");
    if (getObjectCount(sessions) > 0) {
      TerminateSessions(session, callDirection);
      dispatch(removeSessionData(sessionId));
    }
    if (
      Session_Count === 0 &&
      getObjectCount(outgoingSession) > 0 &&
      callDirection === CallDirection.Outbound
    ) {
      TerminateSessions(outgoingSession, CallDirection.Outbound);
    }
    if (
      Session_Count === 0 &&
      getObjectCount(incomingSession) > 0 &&
      callDirection === CallDirection.Inbound
    ) {
      TerminateSessions(incomingSession, CallDirection.Inbound);
    }
    dispatch(setOngoingSessionStatus(SessionState.Terminated));
    // dispatch(setOngoingSessionStatus(SessionState.Terminated))
  };

  /// this function used for call hold or unhold
  const toggelHoldCall = async (state) => {
    try {
      if (getObjectCount(sessions) > 0) {
        session.sessionDescriptionHandlerOptionsReInvite = {
          hold: state, // true for hold call and false for unhold for call
        };

        const options = {
          requestDelegate: {
            onAccept: () => {
              if (state) {
                // session is on hold

                mediaElement.pause();
                setHoldCall(true);
              } else {
                // session is on unhold
                mediaElement.play();

                setHoldCall(false);
              }
            },
            onReject: () => {
              setHoldCall(false);
              // if (state) {
              //   // session is on hold
              //   console.debug('Hold Request Rejected.')
              // } else {
              //   // session is on unhold
              //   console.debug('Unhold Request Accepted.')
              // }
              // // re-invite request was rejected, call not on unhold
              // console.debug('Unhold Request Rejected.')
            },
          },
        };
        await session
          .invite(options)
          .then(() => {
            // console.debug('hold / unhold invite send successfully')
          })
          .catch(() =>
            // error: any
            {
              // console.debug(`Hold Error: ${error}`)
            }
          );
      }
    } catch (error) {
      // console.debug('hold unhold hooks function error', error) // eslint-disable-line  prefer-template
    }
  };

  /// this function used for sessions mute and un mute
  const toggleMuteUnmuteCall = (state) => {
    if (getObjectCount(sessions) > 0) {
      if (state) {
        setMuteCall(true);
      } else {
        setMuteCall(false);
      }

      const pc = session?.sessionDescriptionHandler?.peerConnection;

      if (pc.getSenders) {
        pc.getSenders().forEach((sender) => {
          if (sender.track) {
            sender.track.enabled = !state;
          }
        });
      } else {
        pc.getReceivers().forEach((receiver) => {
          if (receiver.track) {
            receiver.track.enabled = !state;
          }
        });
      }
    }
  };

  /**    sendDTMF : This function will send DTMF event to server. */
  const sendDTMF = (digit) => {
    if (getObjectCount(sessions) > 0) {
      const options = {
        requestOptions: {
          body: {
            contentDisposition: "render",
            contentType: "application/dtmf-relay",
            content: `Signal=${digit}\r\nDuration=1000`,
          },
        },
      };
      session.info(options);
    }
  };

  /**    blindTx : This function will send event to server for blind transfer. */
  const blindTx = async (number) => {
    try {
      // const { SipConfiguration } = store.getState().sip;
      const userSession = sessions[sessionId];
      // Send an outgoing REFER request
      const transferTarget = UserAgent.makeURI(`sip:${number}@${SipConfiguration.sipServer}`);

      if (!transferTarget) {
        throw new Error("Failed to create transfer target URI.");
      }
      userSession.refer(transferTarget, {
        // Example of extra headers in REFER request
        requestOptions: {
          extraHeaders: [
            `Referred-By : sip:${SipConfiguration.sipUsername}@${SipConfiguration.sipServer}`,
          ],
        },
        requestDelegate: {
          onAccept() {
            // callHangUp();
            toast.success("Call Transferred Successfully");
          },
          onReject: () => {
            toast.success("Call Transferred Faild");

            // console.log('reject transfer')
          },
        },
      });
    } catch (error) {
      // console.log('CATCH found - blindTx ==> ', error)
    }
  };
  /**    attendentTx : This function will send invite to target for attendent transfer. */
  const attendentTx = (referSession) => {};

  /**    acceptIncomingCall : This function will accept incoming call. */
  const acceptIncomingCall = async (inboundSession) => {
    await detectAudioVideoPermission();
    const sessionObj = inboundSession.incomingInviteRequest.message.data.toString();
    let has_video = false;
    if (sessionObj.includes("m=video")) {
      has_video = true;
    }
    const options = {
      sessionDescriptionHandlerOptions: {
        constraints: { audio: true, video: has_video },
      },
    };
    inboundSession.accept(options);
  };

  const disconnectSIP = async () => {
    try {
      if (userAgent) {
        userAgent?.transport.dispose();
        userAgent?.disconnect();
      }
      // dispatch(clearSIPCalls());
    } catch (error) {
      console.log("Disconnection Error: ", error);
    }
  };

  return {
    muteCall,
    holdCall,
    connectSIP,
    disconnectSIP,
    dialCall,
    endCall,
    toggelHoldCall,
    toggleMuteUnmuteCall,
    sendDTMF,
    blindTx,
    acceptIncomingCall,
  };
};
